import { Pipe, PipeTransform } from '@angular/core';
import { PayoutMethod, PayoutMethodProvider } from '../services/payout-methods.service';

@Pipe({
  standalone: false,
  name: 'payoutMethodTitle',
})
export class PayoutMethodTitlePipe implements PipeTransform {
  transform(payout: PayoutMethod): string {
    if (payout.provider === PayoutMethodProvider.STRIPE_OAUTH) {
      return payout.name;
    }

    if (payout.provider === PayoutMethodProvider.ADYEN && !payout.name && payout.adyen?.legal_name) {
      return payout.adyen.legal_name;
    } else {
      return payout.name;
    }
  }
}
